<template>
    <div>
        <b-container fluid>
          <b-button :to="{ name: 'Home'}" variant="primary" class="mb-2">Voltar</b-button>

          <full-calendar :events="getEvents" :config="config"></full-calendar>
        </b-container>
    </div>
</template>

<script>
import Agenda from '../services/AgendaService'
import moment from 'moment'
import { FullCalendar } from 'vue-full-calendar'
import 'fullcalendar/dist/fullcalendar.css'

export default {
  name: 'agenda',
  components: {FullCalendar},
  data () {
    return {
      events: [],
      config: {
        eventClick: function (calEvent, jsEvent, view) {
          if (calEvent.title !== undefined) {
            let objeto = calEvent.objeto
            let nome = 'PACIENTE'
            if (objeto.nomepaciente !== undefined) {
              nome = objeto.nomepaciente
            }
            let texto = 'Prezado(a) ' + nome + ', eu Dr. ' + objeto.nomeprofissional.trim() + ' estou realizando este contato, '
            texto = texto.replace(' ', '%20')

            let telefone = objeto.nrocelular.trim()
            telefone = telefone.replace('(', '')
            telefone = telefone.replace(')', '')
            telefone = telefone.replace('-', '')
            telefone = telefone.replace('.', '')

            let url = 'https://api.whatsapp.com/send?phone=55' + telefone + '&text=' + texto + "&source='clinica'&data=&app_absent="
            window.open(url)
          }
          // change the border color just for fun
          // $(this).css('border-color', 'red')
        },
        themeSystem: 'bootstrap4',
        columnHeaderFormat: 'DD/MM',
        allDaySlot: false,
        slotEventOverlap: false,
        eventRender: function (eventObj, $el, view) {
          if (eventObj.title !== undefined) {
            console.log(eventObj)
            let cor = '#' + eventObj.objeto.cor.trim()
            $el.css('background-color', cor)
            $el.find('.fc-title').append('<i class="ml-2 fab fa-whatsapp fa-lg"></i>')
          }
        },
        header: {
          left: 'prev, next, today', // will normally be on the left. if RTL, will be on the right
          center: 'title',
          // right: 'agendaWeek,basicDay,listDay,agendaDay'
          right: 'basicWeek,basicDay,listDay'
        },
        buttonText: {
          today: 'Hoje',
          month: 'mês',
          week: 'semana',
          day: 'dia',
          list: 'lista'
        },
        height: 'auto',
        plugins: [],
        // weekends: false,
        weekends: true,
        // eventLimit: true,
        slotDuration: '00:10:00',
        // defaultView: 'listDay',
        defaultView: 'basicDay',
        firstDay: 1,
        locale: 'pt-br',
        timeFormat: 'HH:mm',
        slotLabelFormat: 'HH:mm',
        minTime: '06:00:00',
        maxTime: '19:00:00'
      }
    }
  },
  created () {
    // this.pesquisa()
    // this.getEvents()
  },
  methods: {

    getEvents (start, end, timezone, callback) {
      this.events = []
      this.pesquisa(start, end, (result) => {
        result.forEach(element => {
          this.events.push({
            start: moment.utc(element.start).toISOString(),
            end: moment.utc(element.end).toISOString(),
            title: element.title,
            objeto: element
            // rendering: 'background'
          })
        })
        callback(this.events)
      })
    },
    pesquisa (start, end, cb) {
      let pesquisa = {}
      const obj = JSON.parse(localStorage.usuarioMC)

      if (obj.empresa !== undefined) {
        pesquisa.empresa = JSON.stringify(obj.empresa)
      }
      const datainicio = start.format('YYYY-MM-DD')
      const datafim = end.format('YYYY-MM-DD')
      pesquisa.datainicio = '"' + datainicio + '"'
      pesquisa.datafim = '"' + datafim + '"'

      if (obj.usuario.cz08_crem !== undefined) {
        pesquisa.crm = obj.usuario.cz08_crem
      }
      Agenda.index(pesquisa).then((result) => {
        if (cb) {
          cb(result)
        }
      }).catch((err) => {
        console.log(err)
      })
    }
  }
}
</script>
<style>
.fc-toolbar .fc-center {
  margin-top: 15px;
}
.fc-day-grid-event .fc-content {
  white-space: normal!important;
  padding: 5px;
}
</style>



// WEBPACK FOOTER //
// src/views/Agenda.vue